/**
 * LockIcon
 *
 * Renders the lock as an inline SVG in all cases.
 *
 * Props:
 *  accentColor  {string}  – fill colour for all paths.
 *                           Defaults to "#fffb00" (original yellow).
 *  width        {string}  – CSS width.  Defaults to "70px".
 *  height       {string}  – CSS height. Defaults to "120px".
 *  style        {object}  – extra inline styles forwarded to the <svg>.
 */
const LockIcon = ({
  accentColor = "#fffb00",
  width = "70px",
  height = "120px",
  style = {},
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 58.7 89.6"
    style={{ width, height, ...style }}
    aria-hidden="true"
  >
    <path
      fill={accentColor}
      d="M53.2,42.9c-1.7-.5-6.7-1.7-17.4-2.1-2,0-4.2-.1-6.5-.1-3.9,0-7.8,0-10.7.3,0,.4.2,1.3-1.1,1.9-.8.3-2,.7-3.7.7-3.9,0-8.5-.3-8.5-.3,2.2.7,8.8,2.2,23.9,2.2,15.1,0,21.7-1.5,23.9-2.2,0,0,.2,0,.2-.2,0-.1-.2-.2-.2-.2ZM43.4,43.8c-2.4,0-4.3-.3-4.3-.8,0-.4,1.9-.8,4.3-.8,2.4,0,4.3.3,4.3.8s-1.9.8-4.3.8Z"
    />
    <path
      fill={accentColor}
      d="M53.2,84v-37.6c-2.7.7-9.6,2.1-24,2.1-5.4,0-9.7-.2-13.2-.5-5.8-.5-10.8,4.1-10.8,10v26c2,.6,8.7,2.2,24,2.2,15.3,0,22-1.6,24-2.2ZM29.2,55.4c3.5,0,6.4,2.9,6.4,6.4,0,3.5-4.3,14.9-6.4,14.9-2.1,0-6.4-11.4-6.4-14.9s2.9-6.4,6.4-6.4Z"
    />
    <path
      fill={accentColor}
      d="M32.9,61.8c0-2-1.6-3.6-3.6-3.6-2,0-3.6,1.6-3.6,3.6,0,2,1.6,3.6,3.6,3.6,2,0,3.6-1.6,3.6-3.6Z"
    />
    <path
      fill={accentColor}
      d="M28.8,3.5c-9.9-.2-18.1,8.2-18.1,18.1v17.5c0,1.3,1,2.3,2.3,2.3h0c.7,0,1.3,0,1.8-.2s.8-.5.8-.9v-18.7c0-7.2,5.9-13.3,13.1-13.2,7,.1,12.7,5.9,12.7,12.9v12.2s.6.7,2.4.7c1.7,0,2.5-.7,2.5-.7v-12.1c0-9.7-7.8-17.6-17.4-17.7Z"
    />
  </svg>
);

export default LockIcon;
